import React, { useEffect, useCallback, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import CommonSwitch from "../switch";
import theme from "../../theme";
import EmployeeList from "./employeeList";
import CommonDropDown from "../dropdown";
import {
  getEmployeeListAction
} from "../../containers/dashboard/action";
import {
  listEmployeeCompanyJoinRequestsAction,
  updateEmployeeCompanyJoinRequestAction,
  employeeCompanyJoinRequestApproveAction,
  employeeCompanyJoinRequestRejectAction,
  updateEmployeeCompanyJoinRequestErrorAction
} from "../../containers/companyDashboard/action";
import { moneyValue } from "../../utils";
import ViewSwitcher from "../viewSwitcher";
import EmploymentApplicationsDemo from "../joinRequest/employeeApplicationList";
import { enqueueSnackbar } from "notistack";

export function getFormattedWorkingDays(workingDays) {
  const objWorkingDays = {
    SUN: 0,
    MON: 1,
    TUE: 2,
    WED: 3,
    THU: 4,
    FRI: 5,
    SAT: 6
  }
  let newObj = {

  }
  if (workingDays) {
    let sortable = []
    workingDays.forEach((key, i) => {

      newObj[key] = objWorkingDays[key]
      sortable.push(key)
    })
    let sorted = sortable.sort((a, b) => newObj[a] - newObj[b])

    return sorted
  }
}
const useStyles = makeStyles(() => ({
  detailContainer: {
    marginTop: "30px",
    "& .block": {
      cursor: "pointer",
      background: theme.colors.White,
      boxShadow: "0px 2px 15px #D0CFDB99",
      borderRadius: "15px",
      padding: "30px",
      display: "flex",
      marginBottom: "15px",
      "& .left": {
        flex: "0.6",
        display: "flex",
        "& .logoContainer": {
          height: "85px",
          width: "85px",
          borderRadius: "50%",
          border: `1px solid ${theme.colors.Zumthor}`,
          backgroundColor: theme.colors.White,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "& img": {
            height: "100%",
            width: "100%",
            objectFit: "cover",
            borderRadius: "50%",
          },
        },
        "& .comInfoContainer": {
          marginLeft: "25px",
          color: theme.colors.Violet,
          width: "60%",
          "& .comName": {
            fontSize: "22px",
            fontFamily: theme.fontFamily.MARKPROBOLD,
            marginBottom: "10px",
          },
          "& .flexContainer": {
            display: "flex",
            alignItems: "center",
            fontSize: "12px",
            fontFamily: theme.fontFamily.MARKPRO,
            "& .changeLink": {
              color: theme.colors.DodgerBlue,
              fontFamily: theme.fontFamily.MARKPRO,
              marginLeft: "5px",
              display: "none",
            },
            "& .label": { fontFamily: theme.fontFamily.MARKPRO, flex: 0.5 },
            "& .val": {
              fontFamily: theme.fontFamily.MARKPROBOLD,
              flex: 0.5,
            },
          },
        },
      },
      "& .right": {
        flex: "0.4",
        display: "flex",
        // alignItems: "center",
        justifyContent: "space-between",
        "& .empNumberContainer": {
          color: theme.colors.Violet,
          "& .label": {
            fontSize: "12px",
            fontFamily: theme.fontFamily.MARKPRO,
          },
          "& .val": {
            fontSize: "16px",
            fontFamily: theme.fontFamily.MARKPROHEAVY,
            "& .currency": {
              fontSize: "10px",
              position: "relative",
              bottom: "4px",
              marginRight: "2px",
            },
          },
        },
        "& .borderContainer": {
          border: `1px solid ${theme.colors.Zumthor}`,
          height: "215px",
          margin: "0px 10px",
        },
      },
    },
  },
  filterContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: "15px",
    marginBottom: "15px",
    width: "100%",

    justifyContent: "space-between",

    "& .title": {
      color: theme.colors.DodgerBlue,
      fontSize: "16px",
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      marginRight: 20,
    },
  },
}));

function CompanyEmployeeDetail({ setSearchEmployee, updateEmployeeMethod }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const getEmployeeListMethod = useCallback(
    (data) => dispatch(getEmployeeListAction(data)),
    [dispatch]
  );
  const listEmployeeCompanyJoinRequestsMethod = useCallback(
    (data) => dispatch(listEmployeeCompanyJoinRequestsAction(data)),
    [dispatch]
  );

  const updateEmployeeCompanyJoinRequestMethod = useCallback(
    (data, request_id) => dispatch(updateEmployeeCompanyJoinRequestAction(data, request_id)),
    [dispatch]
  );

  const employeeCompanyJoinRequestApproveMethod = useCallback(
    (request_id) => dispatch(employeeCompanyJoinRequestApproveAction(request_id)), [dispatch]
  );

  const employeeCompanyJoinRequestRejectMethod = useCallback(
    (request_id, data) => dispatch(employeeCompanyJoinRequestRejectAction(request_id, data)), [dispatch]
  )

  const updateEmployeeCompanyJoinRequestErrorMethod = useCallback(
    (data) => dispatch(updateEmployeeCompanyJoinRequestErrorAction(data)), [dispatch]
  )

  const loginReducer = useSelector((state) => {
    return state.loginReducer;
  });

  const dashboardReducer = useSelector((state) => {
    return state.dashboardReducer;
  });
  const companyDashboardReducer = useSelector((state) => {
    return state.companyDashboardReducer;
  });

  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const page_size = 10;
  const [applicationsPage, setApplicationsPage] = useState(1);
  const [view, setView] = useState("list");
  const applicationsTotalPage = Math.ceil(
    (companyDashboardReducer?.listEmployeeCompanyJoinRequests?.count || 0) / page_size
  );


  useEffect(() => {
    if (loginReducer?.companyInformation?.id) {
      getEmployeeListMethod({
        page,
        page_size,
        company_id: loginReducer.companyInformation.id,
      });
    }
  }, [loginReducer, getEmployeeListMethod, page, page_size]);

  useEffect(() => {
    if (loginReducer?.companyInformation?.id && view === "applications") {
      listEmployeeCompanyJoinRequestsMethod({
        page: applicationsPage,
        page_size,
        company_id: loginReducer.companyInformation.id,
      });
    }
    // Refetch when any mutation lands (approve / reject / edit) so the list reflects it.
  }, [loginReducer, listEmployeeCompanyJoinRequestsMethod, applicationsPage, page_size, view, companyDashboardReducer?.updateEmployeeCompanyJoinRequestSuccess, companyDashboardReducer?.employeeCompanyJoinRequestRejectSuccess, companyDashboardReducer?.employeeCompanyJoinRequestApproveSuccess]);

  useEffect(() => {
    if (
      companyDashboardReducer?.updateEmployeeCompanyJoinRequestError && Array.isArray(companyDashboardReducer?.updateEmployeeCompanyJoinRequestError)) {
      companyDashboardReducer.updateEmployeeCompanyJoinRequestError.forEach((err) => {
        enqueueSnackbar(err, {
          variant: "error", timeout: 2000, onClose: () => {
            updateEmployeeCompanyJoinRequestErrorMethod(null);
          }
        });
      });
    }
    // Approval Errors
    if (
      companyDashboardReducer?.employeeCompanyJoinRequestApproveError &&
      Array.isArray(companyDashboardReducer?.employeeCompanyJoinRequestApproveError)
    ) {

      companyDashboardReducer.employeeCompanyJoinRequestApproveError.forEach((err) => {
        enqueueSnackbar(err, {
          variant: "error", timeout: 2000, onClose: () => {
            // updateEmployeeCompanyJoinRequestErrorMethod(null);
          }
        });
      });
    }

    // Rejection Errors

    if (
      companyDashboardReducer?.employeeCompanyJoinRequestRejectError &&
      Array.isArray(companyDashboardReducer?.employeeCompanyJoinRequestRejectError) &&
      companyDashboardReducer?.employeeCompanyJoinRequestRejectError?.length
    ) {
      companyDashboardReducer.employeeCompanyJoinRequestRejectError.forEach((err) => {
        enqueueSnackbar(err, {
          variant: "error", timeout: 2000, onClose: () => {
            // updateEmployeeCompanyJoinRequestErrorMethod(null);
          }
        });
      });
    }
  }, [
    companyDashboardReducer?.updateEmployeeCompanyJoinRequestError,
    companyDashboardReducer?.employeeCompanyJoinRequestApproveError,
    companyDashboardReducer?.employeeCompanyJoinRequestRejectError
  ])

  // Alert on a successful reject (the applications effect above refetches the
  // list). Ref guard skips whatever value exists on first mount.
  const rejectToastRef = useRef(false);
  useEffect(() => {
    const rejected =
      companyDashboardReducer?.employeeCompanyJoinRequestRejectSuccess;
    if (!rejectToastRef.current) {
      rejectToastRef.current = true;
      return;
    }
    if (rejected) {
      enqueueSnackbar("Company join request rejected.", { variant: "success" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyDashboardReducer?.employeeCompanyJoinRequestRejectSuccess])

  useEffect(() => {
    if (companyDashboardReducer?.listEmployeeCompanyJoinRequests?.count) {
      setTotalPage(Math.ceil(companyDashboardReducer.listEmployeeCompanyJoinRequests.count / page_size));
    }
  }, [dashboardReducer]);


  return (
    <div className={classes.detailContainer}>
      <div className="block">
        <div className="left">
          <div className="logoContainer">
            <img
              src={
                loginReducer?.companyInformation?.image
                  ? loginReducer.companyInformation.image
                  : "/images/no-image-found.png"
              }
              alt="comLogo"
            ></img>
          </div>
          <div className="comInfoContainer">
            <div className="comName">
              {loginReducer?.companyInformation?.name}
            </div>
            {loginReducer?.companyInformation?.admins?.length ? (
              <>
                <div className="flexContainer">
                  <div className="label">Admin:</div>
                  <div className="val">
                    <span>
                      {loginReducer.companyInformation.admins[0].first_name}{" "}
                      {loginReducer.companyInformation.admins[0].last_name}
                    </span>
                    <a href="#" className="changeLink">
                      Change
                    </a>
                  </div>
                </div>

                <div className="flexContainer" style={{ marginTop: "10px" }}>
                  <div className="label">Email:</div>
                  <div className="val">
                    <span>
                      {loginReducer.companyInformation.admins[0].email}
                    </span>
                  </div>
                </div>

                <div className="flexContainer" style={{ marginTop: "10px" }}>
                  <div className="label">Phone Number:</div>
                  <div className="val">
                    {loginReducer.companyInformation.admins[0]?.profile?.phone}
                  </div>
                </div>
              </>
            ) : null}
            <div className="flexContainer" style={{ marginTop: "10px" }}>
              <div className="label">Country:</div>
              <div className="val">
                {loginReducer.companyInformation?.country &&
                  loginReducer?.countryOptions?.length
                  ? loginReducer.countryOptions.find(
                    (each) =>
                      each.id === loginReducer.companyInformation.country
                  ).name
                  : ""}
              </div>
            </div>
            <div className="flexContainer" style={{ marginTop: "10px" }}>
              <div className="label">Currency:</div>
              <div className="val">
                {loginReducer.companyInformation?.currency &&
                  loginReducer?.currencyOptions?.length
                  ? loginReducer.currencyOptions.find(
                    (each) =>
                      each.id === loginReducer.companyInformation.currency
                  ).name
                  : ""}
              </div>
            </div>
            <div className="flexContainer" style={{ marginTop: "10px" }}>
              <div className="label">Time zone:</div>
              <div className="val">
                {loginReducer.companyInformation?.timezone &&
                  loginReducer?.timeZoneOptions?.length
                  ? loginReducer.timeZoneOptions.find(
                    (each) =>
                      each.id === loginReducer.companyInformation.timezone
                  ).name
                  : ""}
              </div>
            </div>
            <div className="flexContainer" style={{ display: "none" }}>
              <div className="label">Account:</div>
              <div className="val">
                <span style={{ fontSize: "12px" }}>Activated</span>
                <CommonSwitch name="checkedA" checked={true} disabled />
              </div>
            </div>
          </div>
        </div>
        <div className="right">
          <div>
            <div
              className="empNumberContainer"
              style={{ marginBottom: "20px" }}
            >
              <div className="label">Total Number of Employees</div>
              <div className="val" style={{ padding: "10px 0px" }}>
                {loginReducer.companyInformation?.total_employees}
              </div>
            </div>
            <div
              className="empNumberContainer"
              style={{ marginBottom: "20px" }}
            >
              <div className="label">Total Number of Registered Employees</div>
              <div className="val" style={{ padding: "10px 0px" }}>
                {loginReducer.companyInformation?.registered_employees}
              </div>
            </div>
            <div className="empNumberContainer">
              <div className="label">Total Monthly Net Salaries</div>
              <div className="val" style={{ padding: "10px 0px" }}>
                <span className={"currency"}>
                  {loginReducer.companyInformation?.currency}
                </span>
                {moneyValue(loginReducer.companyInformation?.net_salaries)}
              </div>
            </div>
          </div>
          <div className="borderContainer" />
          <div>
            <div
              className="empNumberContainer"
              style={{ marginBottom: "20px" }}
            >
              <div className="label">
                Days designated as <br />
                Work Days
              </div>
              <div className="val" style={{ padding: "10px 0px" }}>
                {loginReducer.companyInformation?.days}
                {loginReducer.companyInformation?.formula
                  ? loginReducer.companyInformation.formula === "CALENDAR-DAYS"
                    ? "Calendar Days"
                    : loginReducer.companyInformation.formula ===
                      "BUSINESS-DAYS"
                      ? "Working Days"
                      : ""
                  : ""}
              </div>
            </div>
            <div
              className="empNumberContainer"
              style={{ marginBottom: "20px" }}
            >
              <div className="label">Emp Max Withdrawal % Limit</div>
              <div className="val" style={{ padding: "10px 0px" }}>
                {loginReducer.companyInformation?.employee_withdrawal_limit}%
              </div>
            </div>
            {loginReducer?.companyInformation?.workdays?.length ? (
              <div className="empNumberContainer">
                <div className="label">Working Days</div>
                <div className="val" style={{ padding: "10px 0px" }}>
                  {getFormattedWorkingDays(loginReducer.companyInformation.workdays).join(", ")}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className={classes.filterContainer}>
        <ViewSwitcher
          value={view}
          onChange={setView}
          options={[
            { "label": "List", "value": "list" },
            { "label": "Applications", "value": "applications" }
          ]}
        />
        {view === "list" && <div>
          <div className="title">Search by</div>
          <div
            style={{ width: "200px" }}
            onClick={(e) => {
              e.preventDefault();
              setSearchEmployee(true);
            }}
          >
            <CommonDropDown placeholder={"Search Employee"} options={[]} />
          </div>
        </div>
        }
      </div>
      
        <div className="tableContainer">

          {view === "list" && <EmployeeList
            data={dashboardReducer?.employeeList?.data}
            companyInformation={loginReducer?.companyInformation}
            page={page}
            setPage={setPage}
            totalPage={totalPage}
            updateEmployeeMethod={updateEmployeeMethod}
          />}
          {
            view === "applications" && <EmploymentApplicationsDemo
              handleApprove={(request_id) => {
                employeeCompanyJoinRequestApproveMethod(request_id);
              }}
              handleReject={(request_id, reason) => {
                employeeCompanyJoinRequestRejectMethod(request_id, {
                  reason
                });
              }}
              handleSaveEdit={(id, updatedEmploymentData) => {
                updateEmployeeCompanyJoinRequestMethod({
                  employment_data: updatedEmploymentData,
                }, id);
              }}
              records={companyDashboardReducer?.listEmployeeCompanyJoinRequests?.data || []}
              loading={
                companyDashboardReducer?.listEmployeeCompanyJoinRequestsLoading ||
                companyDashboardReducer?.updateEmployeeCompanyJoinRequestLoading ||
                companyDashboardReducer?.employeeCompanyJoinRequestRejectLoading ||
                companyDashboardReducer?.employeeCompanyJoinRequestApproveLoading}
              page={applicationsPage}
              onPageChange={setApplicationsPage}
              totalPages={applicationsTotalPage}
              saveLoading={companyDashboardReducer?.updateEmployeeCompanyJoinRequestLoading}
              approveLoading={companyDashboardReducer?.employeeCompanyJoinRequestApproveLoading}
              rejectLoading={companyDashboardReducer?.employeeCompanyJoinRequestRejectLoading}
              closeDrawerOnSave={false}
              total={companyDashboardReducer?.listEmployeeCompanyJoinRequests?.count || 0}
            />
          }
        </div>
    </div>
  );
}

export default CompanyEmployeeDetail;
